// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'


Vue.config.productionTip = false



// 设置API的根路径
var axiosInstance = axios.create({
  // baseURL: 'http://localhost:20031'
  baseURL: ''
})

Vue.use(VueAxios, axiosInstance)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})







// WEBPACK FOOTER //
// ./src/main.js